import React , { useState, useEffect } from "react";
import { MdTimer } from "react-icons/md";
import CardItem from "components/card/CardItem";
import Button from "components/button";
import { connect } from "react-redux";
import { 
	doTimeCardPunch, getUserTimeCardToday
} from "../../../../redux/timecard/timeCardState";
import ButtonWithConfirm from "components/button/buttonwithconfirm";

export const TIMECARD_IN = 84;
export const TIMECARD_OUT = 85;

const TimeCard = ({user, recordData, userTimeCardToday, saveTimeCardPunch, ...props}) => {

	const { withClockIn=true, title } = props;
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
      if(user){
        userTimeCardToday({'userId':user.id});
      }
    }, [userTimeCardToday]);

  const onClickTimeInHandler = () => {
    recordData?.tmc_punch_in === null && saveTimeCardPunch({'recordId': recordData.tmc_id, 'typeId': TIMECARD_IN, 'typeName': 'IN'});
  };

  const onClickTimeOutHandler = () => {
    (recordData?.tmc_punch_in !== null && recordData?.tmc_punch_out === null) && saveTimeCardPunch({'recordId': recordData.tmc_id, 'typeId': TIMECARD_OUT, 'typeName': 'OUT'});
  };

  return (
    <CardItem
      icon={<MdTimer className="card-icon"/>}
      title={`${title ? title : "Time Card"}`}
    >

      <div className="text-center">
        <h2 className="mt-[15px] text-xl font-bold text-theme-700 dark:text-white">{currentDateTime.toLocaleDateString(undefined, options)}</h2>
        <h2 className="mb-[15px] text-4xl font-bold text-theme-700 dark:text-white">{currentDateTime.toLocaleTimeString()}</h2>
      </div>

		{(withClockIn && recordData) && 
			<div className="grid grid-cols-1 gap-5 gap-4 px-10 mb-4">
        <Button  
          className={`btn-time-card ${recordData?.tmc_punch_in && 'disabled'}`}
          onClick={onClickTimeInHandler}
          disabled={recordData?.tmc_punch_in}
        > 
          { recordData?.tmc_punch_in ?? 'Time IN' } 
        </Button>
        {recordData?.tmc_punch_in && 
        <ButtonWithConfirm 
          className={`btn-time-card ${(recordData?.tmc_punch_in && recordData?.tmc_punch_out) && 'disabled'}`}
          disabled={recordData?.tmc_punch_out}
          confirmationTitle="Confirm Time OUT"
          confirmHandler={onClickTimeOutHandler}
          > 
            { recordData?.tmc_punch_out ?? 'Time OUT' }
          </ButtonWithConfirm>
        }
      </div> 
		}

    </CardItem>
  );
};

const mapStateToProps = (state) => ({
  recordData: state.timeCard.timeCardDetails?.data,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
  saveTimeCardPunch: (data) => dispatch(doTimeCardPunch(data)),
  userTimeCardToday: (data) => dispatch(getUserTimeCardToday(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeCard);
